/*
 submit-payment.js

 */
import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import core from '../../common/lib/core.js';
import dataflow from '../../common/lib/dataflow.js';
import validateAmount from './validate-amount.js';
import view from './view.js';

const jQuery = window.jQuery; // TODO: todo...

const register = dataflow.register;
const state = {
	methodId: null,
	methodName: null, // used to confirm id and method
	success: null,
	title: null,
	message: null,
	cardnumber: null,
	bonusPaymentMethods: ''
};

function viewUpdate() {
	view.update({
		submit_payment: state
	});
}

function resetInput() {
	state.sendDepositParameters = null;
	state.error = null;
	state.ageverifyerror = null;
	state.complianceerror = null;
	state.buttontext = null;
	state.success = null;
	state.title = null;
	state.currentcard = null;
	state.verificationmsg = null;
}

function hasEqualMethodIds(obj) {
	/* if object has two keys referring to the same payment method, these must be equal */
	const versionA = ((obj.methodId && obj.methodId.toString) && obj.methodId.toString());
	const versionB = ((obj.paymentMethodId && obj.paymentMethodId.toString) && obj.paymentMethodId.toString());
	const equal = Boolean(versionA === versionB);
	if (!equal) {
		console.error('submit_payment:83:hasEqualMethodIds: paymentMethodId and methodId does not correlate:', obj);
	}
	return equal;
}

function errorHandler(err) {
	state.error = true;
	state.title = 'submit-payment:error';
	state.message = 'network connection or remote problems, confirm that you are logged in and connected and try again. Otherwise contact support!';
	console.error('submit-payment:176:errorHandler', err);
	viewUpdate();
}

function noResponseHandler(err) {
	state.success = false;
	state.title = 'The server is not responding.';
	state.message = 'Make sure you are logged in and try again, please.';
	console.error('submit-payment:61:', err);
	viewUpdate();
}

function executePaymentMethod() {
	state.error = false;
	const sendHandlerType = state.sendHandlerType;

	function responseHandler(res) {
		if (res && res.successful) {
			state.success = true;
			state.pending = false;
			viewUpdate();
			actions.submitPayment({
				success: true
			});
			actions.submitPayment({
				success: true,
				sendHandlerData: res.sendHandlerData,
				accHistRef: res.accHistRef,
				paymentFetchResultFlow: res.paymentFetchResultFlow,
				sendHandlerType
			});
		} else {
			state.pending = false;
			console.info('submit_payment:56:can not complete the transaction.', res);
			state.error = true;
			if (res.errorMessage) {
				state.success = false;
				state.title = (res.errorMessage.title || 'some values might be missing');
				state.message = (res.errorMessage.message || 'please try again');
				actions.submitPayment(false);
			}
			viewUpdate();
		}
		resetInput();
		viewUpdate();
	}
	// During redirect for some methods the network info may be lost, so the
	// following console output makes certain values visible. Check the 'preserve log'
	// in chrome devtools console.
	console.info('submit-payment:105:executePaymentMethod: methodUrl', state.methodUrl);
	console.info('submit-payment:104:executePaymentMethod: sendDepositParameters', state.sendDepositParameters);
	console.info('submit-payment:104:executePaymentMethod: sendDepositParameters.am', state.sendDepositParameters.am);
	console.info('submit-payment:104:executePaymentMethod: sendDepositParameters.cu', state.sendDepositParameters.cu);
	core.post(state.methodUrl, state.sendDepositParameters, responseHandler, noResponseHandler);
}

function updateUKCompliance() {
	core.post('/UkComplianceService/ukDepositTandCAgreementRemoveDepositPopup', {
		isMobileDevice: true
	}, (data) => {
		console.info('Response from ukDepositTandCAgreementRemoveDepositPopup');
		console.info(data);
	}, () => {
		console.error('Error from ukDepositTandCAgreementRemoveDepositPopup');
	}, 'application/x-www-form-urlencoded; charset=UTF-8');
}

function requestUseraction(tAndCResponse) {
	/* regarding compliance*/
	state.complianceerror = true;
	state.message = (tAndCResponse && tAndCResponse.UK_DEPOSIT_TERMS_UPDATED) || 'UK_DEPOSIT_TERMS_UPDATED';
	state.title = (tAndCResponse && tAndCResponse.UK_DEPOSIT_TERMS_UPDATED_HEADER) || 'UK_DEPOSIT_TERMS_UPDATED_HEADER';
	viewUpdate();
}

function checkComplianceStatus() {
	state.complianceerror = false;

	function okCb() {
		executePaymentMethod();
	}

	function notOkCb(tAndCResponse) {
		state.pending = false;
		viewUpdate();
		requestUseraction(tAndCResponse);
		//resetInput();
	}

	function compResultHandler(tAndCResponse) {
		if (tAndCResponse.RESULT === 'OK') {
			okCb();
		} else {
			notOkCb(tAndCResponse);
		}
	}
	const requestAndParam = `/UkComplianceService/ukDepositTandCAgreementCheckService?${jQuery.param({
		isMobileDevice: true
	})}`;
	core.get(requestAndParam, compResultHandler, errorHandler);
}

function showVerifyAgeError(verifyAgeData) {
	state.error = true;
	state.ageverifyerror = true;
	state.title = verifyAgeData.ERROR_HEADER || 'CALL_CREDIT_AGE_VERIFY_ERROR_HEADER'; // see comeon-payment-services/comeon-ukcompliance: … UkAgeVeriyfLogic.java
	state.message = verifyAgeData.ERROR || 'CALL_CREDIT_AGE_VERIFY_ERROR';
	// state.buttontext = verifyAgeData.BUTTON_TEXT || 'SIDE_MENU_UPLOAD';
	viewUpdate();
}

function verifyAgeSuccesHandler(verifyAgeData) {
	if (verifyAgeData.RESULT === 'OK') {
		checkComplianceStatus();
	} else {
		state.pending = false;
		resetInput();
		showVerifyAgeError(verifyAgeData);
	}
	viewUpdate();
}

function verifyAgeAndSendDeposit(amount, methodId) {
	state.ageverifyerror = false;
	const ageParameters = {
		am: amount,
		paymentMethod: methodId,
		cu: 'USERSESSIONS_CURRENCY',
		isMobileDevice: true
	};
	core.get(`/UkComplianceService/verifyAgeService?${jQuery.param(ageParameters)}`, verifyAgeSuccesHandler, errorHandler);
}

function registerActions() {
	function submitPayment(payload) {
		let amount = null;
		let creditcardlast = null;
		let card = null;
		let pData = null;
		let mId = null;
		let methodsById = null;
		let selected = null;
		let selectedmethod = null;
		let sendHandlerType = null;
		let methodName = null;
		let methodUrl = null;
		const ukcompliance = (payload.data && payload.data.ukcompliance);
		if (payload.type === constants.PAYMENTMETHODS) {
			/* Get details about payment to prepare for submit.*/
			const currency = (payload.data && payload.data.playerCurrency);
			pData = payload.data;
			selected = (pData && pData.selected);
			methodName = (selected && selected.text);
			// mId = (selected && selected.id);
			mId = (payload.data && payload.data.selectedId);
			methodsById = ((pData && pData.methods) && pData.methods.by_id);
			selectedmethod = ((mId && methodsById) && methodsById[mId]);
			methodUrl = (selectedmethod && selectedmethod.executeUrl);
			sendHandlerType = (selectedmethod && selectedmethod.sendHandlerType);
			state.methodId = mId;
			state.methodName = methodName;
			state.methodUrl = methodUrl;
			state.sendHandlerType = sendHandlerType;
			state.currency = currency;
		}

		if (payload.type === constants.BONUSES) {
			/* Confirmed selected bonus. */
			if (payload.data && {}.hasOwnProperty.call(payload.data, 'selected')) {
				if ({}.hasOwnProperty.call(payload.data.selected, 'id')) {
					state.bid = payload.data.selected.id;
					state.bonusPaymentMethods = payload.data.selected.validPaymentMethods;
				} else {
					console.warn('submit_payment:174:registerActions: property "id" is not in object', payload);
				}
			} else {
				console.warn('submit_payment:167:registerActions: property "selected" is not in object', payload);
			}
		}
		if (payload.type === constants.VIEW_CURRENCYSELECT) {
			// TODO: update backend service(?) to update from currency which happens for some paymentmethods (skrill)
			state.currency = payload.data;
		}
		if (payload.type === constants.VIEW_AMOUNTSELECT) {
			amount = (payload.data && payload.data.amount);
			amount = validateAmount.keepDigits(amount);
			if (amount) {
				state.amount = amount;
				viewUpdate();
			}
		}
		if (payload.type === constants.VIEW_CREDITCARD) {
			state.currentcard = payload.data;
			card = (payload.data && payload.data.card);
			state.cardnumber = ((card && card.cn) || state.cardnumber);
			viewUpdate();
		}
		if (payload.type === constants.VIEW_CREDITCARDLAST) {
			state.currentcard = payload.data;
			state.cardnumber = ((payload.data && payload.data.cn) || null);
			state.error = null;
			state.success = null;
			state.title = null;
			viewUpdate();
		}
		if (payload.type === constants.FETCH_METHODDETAILS) {
			creditcardlast = (payload.data && payload.data.creditcardlast);
			state.cardnumber = (creditcardlast || null);
		}

		if (payload.type === constants.VIEW_PAYMENT_METHOD_LINK) {
			if (state.currentcard && state.currentcard.card) {
				if (state.currentcard.card.cc) {
					state.currentcard.card.cc = null;
					state.refreshinput = true;
				}
			}
			/* reset critical info, like cvc if method is creditcard. */
			viewUpdate();
			/* reset flag after use */
			state.refreshinput = false;
		}
		if (payload.type === constants.VIEW) {
			if (payload.data && payload.data.ageverification && payload.data.ageverification.confirm) {
				resetInput();
			} else if (payload.data && payload.data.ageverification && !payload.data.ageverification.confirm) {
				resetInput();
			}
		}
		if (payload.type === constants.VIEW_PAYMENTFORM) {
			if (ukcompliance && ukcompliance.confirm) {
				updateUKCompliance();
				executePaymentMethod();
			} else if (ukcompliance && !ukcompliance.confirm) {
				// enableDepositButton?
			}
		}
		if (payload.type === constants.VIEW_PAYMENTFORM_SUBMIT) {
			if (payload && payload.data) {
				/* Properties all time present are 'methodId' and 'methodName'. Other properties varies depending on the method. */
				state.sendDepositParameters = payload.data;
				state.sendDepositParameters.isMobileDevice = true;
				state.sendDepositParameters.cu = state.currency;
				/* bonus id */
				if (state.bid !== -1 && state.bonusPaymentMethods && (state.bonusPaymentMethods.split(',').indexOf(String(payload.data.methodId)) > -1
					|| state.bonusPaymentMethods === 'ALL')) {
					state.sendDepositParameters.bid = state.bid;
				}
				state.pending = true;
				viewUpdate();
				amount = state.sendDepositParameters.am;
				if (state.methodUrl && hasEqualMethodIds(state.sendDepositParameters)) {
					/* both the keys 'methodId' and 'paymentMethodId' are used, once in 'getDepositPaymentMethods' and once in the required structure for creditcard. */
					verifyAgeAndSendDeposit(amount, state.methodId);
				}
			} else {
				console.warn('submit_payment:34: can not read payload:', payload);
			}
		}
		if (payload.type === constants.FETCH_FEES_AND_LIMITS) {
			if (payload && payload.data) {
				state.currency = payload.data.selectedCurrency;
			}
		}
	}

	register(submitPayment);
}

export default {
	init() {
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/submit-payment.js